import { render, staticRenderFns } from "./PolicyAppendixNew.vue?vue&type=template&id=3c8fca8f"
import script from "./PolicyAppendixNew.vue?vue&type=script&lang=js"
export * from "./PolicyAppendixNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports